export const url = "/funlink/wiki"
